/**
 * DI-3-P13 — the handle-store key of the folder picked for ONE set
 * (`handle:set:<daId>`, in the existing `handles` store). DI-3-S16-FE — a
 * module of its own: the card's pictures (`flights/previewSource.ts`) and the
 * resume sources (`files/rootFolder.ts`) both read it.
 */
export function setFolderKey(daId: string): string {
  return `handle:set:${daId}`;
}
